module.exports = __webpack_public_path__ + "img/x-icon.5c7a4ec8.svg";